import * as t from './actionType';

const initialState = {
  current: 0,
  total: 5,
};

export function navigationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case t.ASK_FOR_NEXT_STEP:
      return Object.assign({}, state, {
        current: action.step,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/NavigationService/reducers.js